import { displayApiErrorToast } from "core/src/slices/ui/useCases/display-api-error-toast/display-api-error-toast.use-case";
import { postToast, ToastType } from "core/src/slices/ui/useCases/postToast/postToast.use-case";
import { createAppAsyncThunk } from "core/src/store/store.types";
import { EtlApiTarget } from "etl/types";

export type TriggerMergeCsvAndFileRequest = {
	type?: "csv" | "file"
	triggerFilters?: string[]
}

export const triggerMergeCsvAndFile = createAppAsyncThunk<void, TriggerMergeCsvAndFileRequest>(
	"formStep/triggerMergeCsvAndFile",
	async ({ type, triggerFilters }, { getState, extra, dispatch, rejectWithValue }) => {
		try {
			const { selectedEtlImportUuid } = getState().etlData;
			if (!selectedEtlImportUuid) return;

			if (!type || type === "csv") {
				await extra.etlClient.trigger(EtlApiTarget.MERGE_CSV_API, selectedEtlImportUuid, { triggerFilters })
				dispatch(postToast({ message: "Fichier CSV fusionnés avec succès", type: ToastType.SUCCESS }))
			}

			if (!type || type === "file") {
				await extra.etlClient.trigger(EtlApiTarget.MERGE_FILES_API, selectedEtlImportUuid, { triggerFilters })
				dispatch(postToast({ message: "Documents et factures fusionnés avec succès", type: ToastType.SUCCESS }))
			}

		} catch (error: any) {
			dispatch(displayApiErrorToast(error.response))
			throw rejectWithValue(error.response.data.message);
		}
	},
	{
		condition: (_, { getState }) => {
			if (getState().formStep.preProcessRunning) return false;
		}
	}
);
